import { render, staticRenderFns } from "./gatewayRealName.vue?vue&type=template&id=3c38e374&scoped=true&"
import script from "./gatewayRealName.vue?vue&type=script&lang=js&"
export * from "./gatewayRealName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38e374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c38e374')) {
      api.createRecord('3c38e374', component.options)
    } else {
      api.reload('3c38e374', component.options)
    }
    module.hot.accept("./gatewayRealName.vue?vue&type=template&id=3c38e374&scoped=true&", function () {
      api.rerender('3c38e374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/gatewayRealName.vue"
export default component.exports